import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useGetMyTourneyDefinitionIds() {
  const data = useSelector((state) => state?.lobby?.masterTourneysData);

  return useMemo(() => {
    if (!data || typeof data.entries !== "function") return [];
    return Array.from(data.entries())
      .filter(([tourneyId, tourney]) => tourney?.tourneyIdentifier === "myTourneys")
      .sort(([, a], [, b]) => (a.tourneyStartTime || 0) - (b.tourneyStartTime || 0))
      .map(([tourneyId]) => tourneyId);
  }, [data]);
}
